import React, { useEffect, useState } from "react";
import AddressSubmittedForm from "./components/AddressSubmittedForm";
import AddressDetailCom from "./components/AddressDetailCom";
import { useSelector } from "react-redux";
import { RootState } from "../../core/data/redux/store";
import useApi from "../../core/customhook/useApi";
import { disabledStatuses } from "../../core/common/DateValidHelper";

const AddressDetail = () => {
  const reduxDashboardData = useSelector(
    (state: any) => state?.dashboard?.dashboardData,
  );

  const candidateId = reduxDashboardData?.assignmentDetails?.candidate_id;

  const getAddressAPI = useApi<any>(
    `/api/v1/candidates/addresses/${candidateId}`,
    {
      method: "GET",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const [addressStatus, setAddressStatus] = useState("");

  const fetchDetails = async () => {
    try {
      const res = await getAddressAPI.callApi();

      if (!res?.success) return;

      const address = res.data[0];

      setAddressStatus(address?.status);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (candidateId) {
      fetchDetails();
    }
  }, [candidateId]);



  return (
    <>
      {disabledStatuses.includes(addressStatus ?? "") ? (
        <AddressSubmittedForm />
      ) : (
        <AddressDetailCom />
      )}
      {/* {addressStatus === "CANDIDATE_SUBMITTED" ? (
        <AddressSubmittedForm />
      ) : (
        <AddressDetailCom />
      )} */}
      {/* {packageStatus === "SUBMITED" &&
      addressStatus === "CANDIDATE_SUBMITTED" ? (
        <AddressSubmittedForm />
      ) : (
        <AddressDetailCom />
      )} */}
    </>
  );
};

export default AddressDetail;
